import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeViewComponent} from './home-view/home-view.component';
import {ThankYouComponent} from './loan-application/thank-you/thank-you.component';

const routes: Routes = [
  {path: '', component: HomeViewComponent},
  {path: 'cebu', component: HomeViewComponent},
  {path: 'seaman', component: HomeViewComponent},
  {path: 'get-loan', component: HomeViewComponent},
  {path: 'apply-now', component: HomeViewComponent},
  {path: 'apply-now/1', redirectTo: '/apply-now', pathMatch: 'full'},
  {path: 'apply-now/2', redirectTo: '/apply-now', pathMatch: 'full'},
  {path: 'ofw-loan', component: HomeViewComponent},
  {path: 'seaman-loan', component: HomeViewComponent},
  {path: 'thank-you', component: ThankYouComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {
}
